import { Award } from "lucide-react";
import { useContent, resolveImage } from "../contexts/ContentContext";

export const Sponsors = () => {
  const { data: sponsors } = useContent("sponsors");
  if (!sponsors) return null;

  const items = sponsors.items || [];
  // Duplicate for seamless marquee loop.
  const track = items.length > 0 ? [...items, ...items] : [];

  return (
    <section id="sponsors" data-testid="sponsors-section" className="py-16 md:py-20 bg-slate-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <span className="section-eyebrow">
            <Award className="w-3.5 h-3.5" />
            {sponsors.eyebrow}
          </span>
          <h2 data-testid="sponsors-heading" className="mt-4 font-display text-2xl md:text-4xl font-bold tracking-tight text-slate-900">
            {sponsors.heading}
          </h2>
          {sponsors.intro && <p className="mt-3 text-sm md:text-base text-slate-600 max-w-2xl mx-auto">{sponsors.intro}</p>}
        </div>
      </div>

      <div className="mt-12 relative">
        <div aria-hidden="true" className="pointer-events-none absolute left-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-r from-slate-50 to-transparent z-10" />
        <div aria-hidden="true" className="pointer-events-none absolute right-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-l from-slate-50 to-transparent z-10" />

        <div className="overflow-hidden">
          <div className="flex gap-6 md:gap-8 w-max sponsors-track" data-testid="sponsors-track">
            {track.map((s, i) => {
              const Shell = s.url ? "a" : "div";
              const shellProps = s.url ? { href: s.url, target: "_blank", rel: "noopener noreferrer" } : {};
              return (
                <Shell
                  key={`${s.name}-${i}`}
                  {...shellProps}
                  data-testid={`sponsor-${i % items.length}`}
                  className="shrink-0 w-48 md:w-64 h-28 md:h-32 rounded-2xl bg-white border border-slate-100 shadow-[0_6px_20px_rgba(15,23,42,0.04)] grid place-items-center p-6 transition-transform hover:-translate-y-1"
                >
                  {s.logo ? (
                    <img src={resolveImage(s.logo)} alt={s.name} className="w-full h-full object-contain" loading="lazy" />
                  ) : (
                    <div className="flex flex-col items-center gap-1 opacity-60">
                      <span className="w-10 h-10 rounded-xl bg-slate-100 grid place-items-center text-slate-400 text-xs font-bold">LOGO</span>
                      <p className="text-[10px] uppercase tracking-[0.18em] text-slate-400 font-semibold">{s.name || "Your Logo Here"}</p>
                    </div>
                  )}
                </Shell>
              );
            })}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-10 text-center">
        <p className="text-xs text-slate-500 max-w-md mx-auto">
          Interested in sponsoring a program, a location, or a season?{" "}
          <a href="#get-involved" data-testid="sponsors-cta-link" className="text-[#2563EB] font-semibold hover:underline">
            Reach out →
          </a>
        </p>
      </div>
    </section>
  );
};
